import { createAction, union } from '@ngrx/store';
import { META_PREFIX } from '../constants';

const reset = createAction(`${META_PREFIX} reset`);
const noAction = createAction(`${META_PREFIX} no action`);

const all = union({
  reset
});

// exporting the type of actions here to make sure that we can use the correct type in effects
export type MetaActionTypes = typeof all;

export const MetaActions = {
  reset,
  noAction
};
